import { Budget } from '@/db/schema/_types'
import { Account } from '@/db/schema/account'
import { BexioContact, BexioOrder } from '@/lib/bexio-schema'
import { sql } from 'drizzle-orm'
import { check, index, pgEnum, pgTable, serial, text, timestamp, unique } from 'drizzle-orm/pg-core'

export const projectStatusType = pgEnum('project_status_type', ['open', 'closed', 'requested', 'rejected'])
export const projectType = pgEnum('project_type', ['internal', 'external'])
export const project = pgTable(
  'project',
  {
    id: serial('id').primaryKey(),
    migrationId: text('migration_id'), // Migration ID
    slug: text('slug')
      .notNull()
      .default(sql`gen_random_uuid()`)
      .unique(),
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    status: projectStatusType().notNull(),
    name: text('name').notNull(),
    description: text('description'),
    responsible: text('responsible'),
    url: text('url'),
    type: projectType().notNull(), // Assume 'internal' or 'external'
    bexioContactId: text('bexio_contact_id'),
    bexioOrderId: text('bexio_order_id'),
  },
  (t) => ({
    uniqueBexioEntry: unique('project_unique_bexio_entry').on(t.bexioContactId, t.bexioOrderId),
    slugIdx: index('project_slug_idx').on(t.slug),
    bexioContactIdIdx: index('project_bexio_contact_id_idx').on(t.bexioContactId),
    projectTypeCheck: check(
      'project_type_check',
      sql`(
        (${t.type} = 'internal' AND ${t.bexioContactId} IS NULL AND ${t.bexioOrderId} IS NULL) OR
        (${t.type} = 'external' AND ${t.bexioContactId} IS NOT NULL)
      )`
    ),
  })
)

export type Project = typeof project.$inferSelect & {
  bexioContact?: BexioContact
  bexioOrder?: BexioOrder
  accounts?: Account[]
  budget?: Budget
  /** Bexio could not be reached, so `bexioContact`/`bexioOrder` and the external budget are missing. */
  bexioDegraded?: boolean
  /** The degradation is our own token being refused, not Bexio being unreachable (#771). */
  bexioTokenExpired?: boolean
}
export type InsertProject = typeof project.$inferInsert
export type UpdateProject = Partial<Project>
